import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { serviceApi } from '~/features';
import { SponsoredProductsReportsBannerDto } from '~/types';

export const DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_PRODUCT_MUTATION_KEY =
  'DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_PRODUCT_MUTATION';

async function exportSponsoredProductsProductDailyReport(
  params: SponsoredProductsReportsBannerDto
) {
  return serviceApi.get<Blob>(
    `/ReportProdutoPatrocinado/DailyRegister-Export`,
    {
      params,
      responseType: 'blob',
    }
  );
}

export function useDownloadSponsoredProductsReportsBanner(
  onSuccess?: (
    data: AxiosResponse<Blob, unknown>,
    variables: SponsoredProductsReportsBannerDto,
    context: SponsoredProductsReportsBannerDto
  ) => unknown,
  onError?: (
    error: Error,
    variables: SponsoredProductsReportsBannerDto,
    context: SponsoredProductsReportsBannerDto | undefined
  ) => unknown
) {
  return useMutation({
    mutationKey: [DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_PRODUCT_MUTATION_KEY],
    mutationFn: async (params: SponsoredProductsReportsBannerDto) =>
      exportSponsoredProductsProductDailyReport(params),
    onSuccess,
    onError,
  });
}
